class SandlotCollectionNavigation extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('[data-navigation-track]');
    const arrows = this.querySelector('[data-navigation-arrows]');
    const previous = this.querySelector('[data-navigation-prev]');
    const next = this.querySelector('[data-navigation-next]');
    if (!track || !arrows || !previous || !next) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const rtl = () => getComputedStyle(track).direction === 'rtl';
    const update = () => {
      arrows.hidden = track.scrollWidth <= track.clientWidth + 2;
      if (arrows.hidden || !track.firstElementChild) return;
      const bounds = track.getBoundingClientRect();
      const first = track.firstElementChild.getBoundingClientRect();
      const last = track.lastElementChild.getBoundingClientRect();
      previous.disabled = rtl() ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2;
      next.disabled = rtl() ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2;
    };
    const move = direction => {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = ((track.firstElementChild?.getBoundingClientRect().width || 140) + gap) * 2;
      track.scrollBy({left: direction * (rtl() ? -1 : 1) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    track.addEventListener('scroll', update, {...options, passive: true});
    this.observer = new ResizeObserver(update);
    this.observer.observe(track);
    update();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}
if (!customElements.get('sandlot-collection-navigation')) customElements.define('sandlot-collection-navigation', SandlotCollectionNavigation);
